import React from 'react'

const MobileFiltersSort = () => {
	return (
		<div>
			<div>
				<div className='mb-3'>
					<h5 className='text-normal text-black'>Sort By</h5>
				</div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Price (Highest First)
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Discount
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Price (Lowest First)
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						What's New
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Relevance
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						New Arrivals
					</label>
				</div>
			</div>
		</div>
	)
}

export default MobileFiltersSort
